import React from "react";
import { useParams } from "wouter";
import { Transaction } from ".";
import { useQueryState } from "../../../../components/src/use-query-state";
import { serializeDate } from "../../../../components/src/dateFormater";

export const TransactionView = (): React.ReactElement => {
    const { id } = useParams<{ id: string }>();
    const [queryStartDate] = useQueryState("startDate", "");
    const selectedClientIds = id && id !== "all" ? [id] : [];

    let startDate;
    if (queryStartDate) {
        startDate = serializeDate(new Date(queryStartDate));
    } else if (id) {
        startDate = serializeDate(new Date(new Date().setDate(new Date().getDate() - 30)));
    } else {
        startDate = serializeDate(new Date(new Date().setDate(new Date().getDate() - 10)));
    }

    const endDate = serializeDate("2099-01-01");

    return (
        <div>
            <Transaction
                clientIds={selectedClientIds}
                startDate={startDate}
                endDate={endDate}
            />
        </div>
    );
};
